import { Alert } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useRef } from 'react';
import { useToastQueue } from '../app-error/use-toast-queue';

export const ErrorToast = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { toasts, dismissToast } = useToastQueue();

  const displayed = useRef<Set<string>>(new Set());

  useEffect(() => {
    toasts.forEach((toast) => {
      if (!toast.message) {
        return;
      }

      if (!displayed.current.has(toast.id)) {
        enqueueSnackbar(toast.message, {
          key: toast.id,
          variant: toast.severity,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          autoHideDuration: 6000,
          content: (key) => (
            <Alert
              data-testid="toast"
              data-severity={toast.severity}
              onClose={() => closeSnackbar(key)}
              severity={toast.severity}
              variant="filled"
              sx={{ minWidth: 300 }}
            >
              {toast.message}
            </Alert>
          ),
          onClose: () => {
            dismissToast(toast.id);
            displayed.current.delete(toast.id);
          },
        });

        displayed.current.add(toast.id);
      }
    });

    displayed.current.forEach((id) => {
      if (!toasts.some((queued) => queued.id === id)) {
        displayed.current.delete(id);
      }
    });
  }, [toasts, enqueueSnackbar, closeSnackbar, dismissToast]);

  return null;
};
